var _rect, _rect2, _path, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImageAvailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 70,
    width: 472,
    height: 220,
    rx: 20,
    fill: "#E5E7EB",
    stroke: "#CBD5E1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 242L245 155L322 219L393 180L490 242",
    stroke: "#94A3B8",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 137,
    r: 26,
    fill: "#CBD5E1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 309,
    textAnchor: "middle",
    fill: "#64748B",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "\n    No Image Available\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageAvailable);
export default __webpack_public_path__ + "static/media/no-image-available.6ddad2750828f5e2188989c312141e0b.svg";
export { ForwardRef as ReactComponent };